import React from 'react';
import * as S from './styles';

interface IButton {
  className?: string;
  label: any;
  onClick?: any;
  second?: boolean;
  disable?: boolean;
  width?: number;
}

const Button = ({ className, label, onClick, second, disable, width }: IButton) => (
  <S.Button
    className={className}
    onClick={!disable ? onClick : undefined}
    second={second}
    disable={disable}
    width={width}
  >
    {label}
  </S.Button>
);

export default Button;
